<template>
    <b-container fluid>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="text-left my-3">
                <inter-card>
                    <h4 class="text-primary">Riepilogo</h4>
                    <p>Di seguito un riepilogo della richiesta inserita; se corretta, clicca sul pulsante '<strong>INVIA RICHIESTA</strong>' per concludere la procedura.<br />Finch&eacute; lo stato della richiesta sarà '<strong>IN ATTESA DI PAGAMENTO</strong>' sar&agrave; possibile modificarla; una volta effettuato, invece, non sarà pi&ugrave; possibile apportare cambiamenti.</p>
                </inter-card>
            </b-col>
            <b-col cols="12" md="8">
                <inter-card class="my-3"
                            :noBody="true"
                            titleIcon="flaticon-menu"
                            title="Riepilogo">
                    <b-list-group>
                        <b-list-group-item v-for="(item, index) in recap" v-bind:key="index">
                            <div class="d-flex">
                                <div>{{item.label}}</div>
                                <div class="ml-auto text-primary">{{item.value}}</div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </inter-card>
            </b-col>
        </b-row>
        <hr>
        <b-row class="justify-content-center">
            <b-col cols="12" md="5" class="mb-3">
                <inter-card
                        :noBody="true"
                        titleIcon="flaticon-baby"
                        :title="`Minori [ ${totalJunior} ]`">
                    <div v-if="juniorContacts.length">
                        <b-list-group class="list-contacts">
                            <b-list-group-item v-for="(contact, index) in juniorContacts" v-bind:key="index">
                                <div class="d-flex">
                                    <div>{{contact.surname}} {{contact.name}}</div>
                                    <div class="ml-auto small text-primary">
                                        {{contact.birth_date | date}}
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                    <div v-else>
                        <b-alert variant="warning" show>
                            Non ci sono contatti minorenni
                        </b-alert>
                    </div>
                </inter-card>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <inter-card
                        :noBody="true"
                        titleIcon="flaticon-employee"
                        :title="`Adulti [ ${totalSenior} ]`">
                    <div v-if="seniorContacts.length">
                        <b-list-group class="list-contacts">
                            <b-list-group-item v-for="(contact, index) in seniorContacts" v-bind:key="index">
                                <div class="d-flex">
                                    <div>{{contact.surname}} {{contact.name}}</div>
                                    <div class="ml-auto small text-primary">
                                       {{contact.birth_date | date}}
                                    </div>
                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                    <div v-else>
                        <b-alert variant="warning" show>
                            Non ci sono contatti maggiorenni
                        </b-alert>
                    </div>
                </inter-card>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>

    import InterCard from "../../../../components/card/InterCard";
    import _ from 'lodash';
    import Moment from 'moment';
    import MatchRequest from "@/models/MatchRequest";
    import Utils from "@/utils";

    export default {
        name: "SocietyMatchWizardsStepFive",
        components: {InterCard},
        props: {
            matchRequest: {
                type: Object,
                default: () => Object.assign({}, MatchRequest)
            }
        },

        computed: {
            recap: function () {
                let items = [];
                items.push({
                    label: 'Partita',
                    value: this.matchRequest.match.opponent
                });
                items.push({
                    label: 'Data',
                    value: Utils.setDateFormatITA(this.matchRequest.match.date)
                });
                items.push({
                    label: 'Adulti / Minori',
                    value: '1 : ' + this.matchRequest.match.adult_vs_childs
                });
                items.push({
                    label: 'Posti riservati',
                    value: this.totalSenior + this.totalJunior
                });
                items.push({
                    label: 'Importo',
                    value: Utils.setCurrencyFormat(this.totalAmount)
                });
                return items;
            },
            juniorContacts: function () {
                const list = _.filter(this.matchRequest.details, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age < 18;
                });
                return _.sortBy(list, ['surname'])
            },
            seniorContacts: function () {
                const list = _.filter(this.matchRequest.details, (item) => {
                    const age = Moment().diff(item.birth_date, 'years', false);
                    return age >= 18;
                });
                return _.sortBy(list, ['surname'])
            },
            totalSenior: function () {
                return _.filter(this.seniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalJunior: function () {
                return _.filter(this.juniorContacts, (item) => {
                    return item.selected;
                }).length;
            },
            totalAmount: function () {
                return (this.totalJunior + this.totalSenior) * this.matchRequest.match.price;
            }
        },
    }
</script>

<style scoped lang="scss">

    .list-contacts {
        min-height: 150px;
        max-height: 266px;
        overflow: auto;
    }

</style>
